import {AfterViewInit, Component} from '@angular/core';
import {DeliveryAddressInputFragmentController} from './DeliveryAddressInputFragmentController';
import {MatDialog} from '@angular/material/dialog';
import {BaseViewUI} from '../../../../../BaseUI/BaseViewUI/BaseViewUI';
import {Router} from '@angular/router';
import {patternForName, patternForPostCode} from '../../../../../../Util/StringUtil';
import {UserDeliveryAddressDTOInterface} from '../../../../../../DTO/UserDeliveryAddressDTOInterface';
import {PrefectureConst} from '../../../../../../Enum/PrefectureConst';
import {MatRadioChange} from '@angular/material/radio';
import {ExamAfterProcessInitialDataDTOInterface} from '../../../../../../DTO/ExamAfterProcessInitialDataDTOInterface';
import {PrescriptionDeliveryTargetConst} from '../../../../../../Enum/PrescriptionDeliveryTargetConst';
import {PopoverConfirmComponent} from '../../../../../Common/Popover/Confirm/PopoverConfirmComponent';
import {HomeAddressOverridePopoverComponent} from './HomeAddressOverridePopover/HomeAddressOverridePopoverComponent';

@Component({
	selector: 'app-reserve-component',
	templateUrl: './DeliveryAddressInputFragmentComponent.html',
	styleUrls: ['../ExamAfterProcessLayout.scss', './DeliveryAddressInputFragmentComponent.scss'],
})


export class DeliveryAddressInputFragmentComponent extends BaseViewUI implements AfterViewInit {

	// 紐付いたコントローラー
	public combineCtrl: DeliveryAddressInputFragmentController;

	// 親から渡される関数
	public eventNextPage: (data: ExamAfterProcessInitialDataDTOInterface) => void;
	public registerMedicineDeliveryAddress: (data: UserDeliveryAddressDTOInterface) => ExamAfterProcessInitialDataDTOInterface;
	public registerPrescriptionDeliveryAddress: (data: UserDeliveryAddressDTOInterface) => ExamAfterProcessInitialDataDTOInterface;
	public registerStoreAddress: (data: UserDeliveryAddressDTOInterface) => ExamAfterProcessInitialDataDTOInterface;

	public deleteMedicineDeliveryAddress: (data: UserDeliveryAddressDTOInterface) => ExamAfterProcessInitialDataDTOInterface;
	public deletePrescriptionDeliveryAddress: (data: UserDeliveryAddressDTOInterface) => ExamAfterProcessInitialDataDTOInterface;
	public deleteStoreAddress: (data: UserDeliveryAddressDTOInterface) => ExamAfterProcessInitialDataDTOInterface;

	public openEditHomeAddress: (data: UserDeliveryAddressDTOInterface) => void;
	public openEditMedicineDeliveryAddress: (data: UserDeliveryAddressDTOInterface) => void;
	public openEditPrescriptionDeliveryAddress: (data: UserDeliveryAddressDTOInterface) => void;
	public openEditStoreAddress: (data: UserDeliveryAddressDTOInterface) => void;


	public errors = [];

	public data: ExamAfterProcessInitialDataDTOInterface = {
		examAfterProcess: {
			id: 0,
			userId: 0,
			paymentId: 0,
			reservationId: 0,
			isMedicine: 0,
			isPrescription: 0,
			prescriptionAddressId: 0,
			prescriptionDeliveryTarget: 0,
			medicineAddressId: 0,
			status: 0,
			hash: null,
		},
		user: {
			id: 0,
			lineId: '',
			lineTokenId: 0,
			lastname: '',
			middlename: '',
			firstname: '',
			lastnameKana: '',
			firstnameKana: '',
			nameRoman: null,
			passportNo: null,
			nationalityId: null,
			gender: '',
			birthday: '',
			telNumber: '',
			deviceType: '',
			postCode: '',
			prefecture: '',
			city: '',
			address: '',
			building: '',
			toName: '',
			email: '',
			password: '',
			anonymousCode: 1,
			userNotes: '',
		},
		payment: {
			id: 0,
			userId: 0,
			orcaUsername: null,
			orcaPatient: null,
			itemPrice: 0,
			processCode: '',
			state: 0,
			paymentCode: null,
			conveniState: 0,
			conveniName: null,
			payFlag: 0,
			processUrl: '',
			performDate: null,
			remark: null,
			receiptId: null,
			reservationId: null,
			isDirty: false,
			isMerged: false,
			mergedId: null,
			isHide: false,
		},
		primaryAddress: {
			id: 0,
			userId: 0,
			storeName: '',
			postCode: '',
			prefecture: '',
			city: '',
			address: '',
			building: '',
			toName: '',
			telNumber: '',
			faxNumber: '',
		},
		isValidPrimaryAddress: false,
		storeAddressList: [],
		homeAddressList: [],
		selectedPrescriptionDeliveryAddress: {
			id: 0,
			userId: 0,
			storeName: '',
			postCode: '',
			prefecture: '',
			city: '',
			address: '',
			building: '',
			toName: '',
			telNumber: '',
			faxNumber: '',
		},
		selectedPrescriptionFaxStore: {
			id: 0,
			userId: 0,
			storeName: '',
			postCode: '',
			prefecture: '',
			city: '',
			address: '',
			building: '',
			toName: '',
			telNumber: '',
			faxNumber: '',
		},
		selectedMedicineDeliveryAddress: {
			id: 0,
			userId: 0,
			storeName: '',
			postCode: '',
			prefecture: '',
			city: '',
			address: '',
			building: '',
			toName: '',
			telNumber: '',
			faxNumber: '',
		},
		countAvailableMedicineDeliveryAddress: 0,
		countAvailableStoreDeliveryAddress: 0,
		isInputComplete: false,
		epsilon: {
			id: 0,
			paymentId: 0,
			itemCode: '',
			itemName: '',
			itemPrice: 0,
			stCode: '',
			missionCode: '',
			processCode: '',
			state: 0,
			paymentCode: 0,
			conveniState: 0,
			conveniName: '',
			processUrl: '',
			payFlag: 0,
		}
	};


	public prefectureList = PrefectureConst.getList();

	// 薬の送付先
	public isOpenCreateMedicineDeliveryAddressForm = false;
	public newMedicineDeliveryAddress: UserDeliveryAddressDTOInterface = {
		id: 0,
		type: 'PRIMARY',
		userId: 0,
		storeName: '',
		postCode: '',
		prefecture: '',
		city: '',
		address: '',
		building: '',
		toName: '',
		telNumber: '',
		faxNumber: '',
	};
	public errorMedicineDeliveryAddress = [];

	public isOpenCreatePrescriptionDeliveryAddressForm = false;
	public newPrescriptionDeliveryAddress: UserDeliveryAddressDTOInterface = {
		id: 0,
		type: 'PRIMARY',
		userId: 0,
		storeName: '',
		postCode: '',
		prefecture: '',
		city: '',
		address: '',
		building: '',
		toName: '',
		telNumber: '',
		faxNumber: '',
	};
	public errorPrescriptionDeliveryAddress = [];

	// 処方箋 薬局FAX
	public isOpenCreatePrescriptionFaxStoreForm = false;
	public newPrescriptionFaxStoreAddress: UserDeliveryAddressDTOInterface = {
		id: 0,
		userId: 0,
		storeName: '',
		postCode: '',
		prefecture: '',
		city: '',
		address: '',
		building: '',
		toName: '',
		telNumber: '',
		faxNumber: '',
	};
	public errorPrescriptionFaxStore = [];

	public deleteTargetMedicineDeliveryAddress: UserDeliveryAddressDTOInterface = null;
	public deleteTargetStore: UserDeliveryAddressDTOInterface = null;
	public deleteTargetPrescriptionDeliveryAddress: UserDeliveryAddressDTOInterface = null;

	public selectedMedicineDeliveryAddressId = -1;

	// 処方箋送付先
	public selectedPrescriptionDeliveryAddressId = 0;
	// 処方箋FAX先薬局
	public selectedPrescriptionFaxStoreId = 0;


	public addressTypeList = [
		{id: 'PRIMARY', name: '自宅'},
		{id: 'OTHER', name: 'その他'},
	];

	/**
	 * constructor
	 */
	constructor(public dialogCtrl: MatDialog,
				public route: Router) {

		super();

		// コントローラーの生成
		this.createController(DeliveryAddressInputFragmentController);

	}

	/**
	 * ngAfterViewInit
	 *
	 * Angularのライフサイクル
	 * ビューの初期化後に一度だけ実行される
	 */
	public async ngAfterViewInit() {
	}


	/**
	 * 開始処理
	 */
	public async start() {
		this.selectedMedicineDeliveryAddressId = this.data.selectedMedicineDeliveryAddress.id;
		/*
		const initialData = await this.execFuncWithErrorHandling(
			this,
			await this.combineCtrl.getInitialData.bind(this),
			{view: this, reserve: this.reserveModel, startDate: this.startDate, count: this.getDayNumber}
		);
		*/
	}


	/**
	 * 郵便番号から住所を自動入力
	 */
	public async onClickAutoInputAddress(target: string) {
		this.log('Component::onClickAutoInputAddress()');
		let postCode = '';

		switch (target) {
			case 'medicine':
				postCode = this.newMedicineDeliveryAddress.postCode;
				break;

			case 'prescription':
				postCode = this.newPrescriptionDeliveryAddress.postCode;
				break;

			case 'store':
				postCode = this.newPrescriptionFaxStoreAddress.postCode;
				break;
		}
		const ret = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.getAddress.bind(this),
			{ view: this, postCode }
		);
		if (!ret) {
			return;
		}

		switch (target) {
			case 'medicine':
				this.newMedicineDeliveryAddress.prefecture = ret.prefecture;
				this.newMedicineDeliveryAddress.city = ret.city;
				break;

			case 'prescription':
				this.newPrescriptionDeliveryAddress.prefecture = ret.prefecture;
				this.newPrescriptionDeliveryAddress.city = ret.city;
				break;

			case 'store':
				this.newPrescriptionFaxStoreAddress.prefecture = ret.prefecture;
				this.newPrescriptionFaxStoreAddress.city = ret.city;
				break;
		}

	}


	public async onChangePrescriptionDeliveryType(event: MatRadioChange): Promise<void> {
		//await this.closeCreatePrescriptionDeliveryAddressForm();
	}

	/**
	 * 処方箋送付先変更時のコールバック
	 * @param event
	 */
	public async onChangePrescriptionDeliveryAddressId(event: MatRadioChange): Promise<void> {
		await this.closeCreatePrescriptionDeliveryAddressForm();
	}

	/**
	 *
	 * @param event
	 */
	public async onChangeMedicineDeliveryType(event: MatRadioChange): Promise<void> {
		await this.closeCreateMedicineDeliveryAddressForm();
	}

	/**
	 * 処方箋のFAX先の選択肢変更時のコールバック
	 * @param event
	 */
	public async onChangePrescriptionFaxStoreId(event: MatRadioChange): Promise<void> {
		await this.closeCreatePrescriptionFaxStoreForm();
	}

	/**
	 * データ保存して支払い画面へ遷移させる
	 */
	public async onClickConfirm(): Promise<void> {

		this.errors = [];
		if (this.data.examAfterProcess.isMedicine === 1) {
			if (this.selectedMedicineDeliveryAddressId === 0) {
				this.errors.push({
					message: 'お薬の送付先を選択してください。'
				});
			}
		}

		if (this.data.examAfterProcess.isPrescription === 1) {
			switch (this.data.examAfterProcess.prescriptionDeliveryTarget) {
				case PrescriptionDeliveryTargetConst.HOME:
					if (this.selectedPrescriptionDeliveryAddressId === 0) {
						this.errors.push({
							message: '処方箋の送付先を選択してください。'
						});
					}
					break;
				case PrescriptionDeliveryTargetConst.STORE:
					if (this.selectedPrescriptionFaxStoreId === 0) {
						this.errors.push({
							message: '処方箋をFAXする薬局を選択してください。'
						});
					}
					break;

				default:
					this.errors.push({
						message: '処方箋の受け取り方法を選択してください。'
					});
					break;
			}
		}

		if (this.errors.length > 0) {
			const messageList = this.errors.map((item) => item.message);
			this.showAlertDialog('エラー', messageList.join('<br>'));
			return;
		}

		// お薬送付先の設定
		this.data.examAfterProcess.medicineAddressId = this.selectedMedicineDeliveryAddressId;
		// 処方箋送付先の設定
		switch (this.data.examAfterProcess.prescriptionDeliveryTarget) {
			case PrescriptionDeliveryTargetConst.HOME:
				this.data.examAfterProcess.prescriptionAddressId = this.selectedPrescriptionDeliveryAddressId;
				break;

			case PrescriptionDeliveryTargetConst.STORE:
				this.data.examAfterProcess.prescriptionAddressId = this.selectedPrescriptionFaxStoreId;
				break;
		}

		await this.eventNextPage(this.data);
	}

	/**
	 * データの初期化
	 * @param data
	 * @param scope
	 */
	public async setInitialData(data: ExamAfterProcessInitialDataDTOInterface, scope: string = 'all'): Promise<void> {
		this.data = data;

		switch (scope) {
			case 'all':
				this.selectedMedicineDeliveryAddressId = this.data.selectedMedicineDeliveryAddress.id;
				this.selectedPrescriptionDeliveryAddressId = this.data.selectedPrescriptionDeliveryAddress.id;
				this.selectedPrescriptionFaxStoreId = this.data.selectedPrescriptionFaxStore.id;
				break;

			// お薬の送付先
			case 'medicineDeliveryAddress':
				this.selectedMedicineDeliveryAddressId = this.data.selectedMedicineDeliveryAddress.id;
				break;

			// 処方箋の送付先
			case 'prescriptionDeliveryAddress':
				this.selectedPrescriptionDeliveryAddressId = this.data.selectedPrescriptionDeliveryAddress.id;
				break;

			// 処方箋FAX先
			case 'prescriptionFaxStore':
				this.selectedPrescriptionFaxStoreId = this.data.selectedPrescriptionFaxStore.id;
				break;
		}

	}

	/**
	 * お薬の送付先住所の登録
	 */
	public async onClickRegisterMedicineDeliveryAddress(): Promise<void> {
		// データ検証
		this.errorMedicineDeliveryAddress = [];
		this.errorMedicineDeliveryAddress = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.validateMedicineDeliveryAddressData.bind(this),
			{ view: this, data: this.newMedicineDeliveryAddress }
		);
		if (this.errorMedicineDeliveryAddress.length > 0) {
			const massageList = this.errorMedicineDeliveryAddress.map((item) => item.message);
			this.showAlertDialog('住所登録エラー', massageList.join('<br>'));
			return;
		}

		// 自宅住所として登録する場合、上書きするかの確認ダイアログを表示
		// 自宅住所が登録されていない場合は表示しない
		if (this.newMedicineDeliveryAddress.type === 'PRIMARY' && this.data.isValidPrimaryAddress === true) {
			await this.showDialogWindow(
				HomeAddressOverridePopoverComponent,
				{
					userDeliveryAddress: this.newMedicineDeliveryAddress,
					primaryAddress: this.data.primaryAddress,
					registerAddress: this.execRegisterMedicineDeliveryAddress.bind(this),
					close: this.dismissDialogWindow.bind(this),
				}
			);
		} else {
			await this.execRegisterMedicineDeliveryAddress(this.newMedicineDeliveryAddress);
		}

	}

	public async execRegisterMedicineDeliveryAddress(data: UserDeliveryAddressDTOInterface): Promise<void> {
		console.log(data);
		const res = await this.registerMedicineDeliveryAddress(data);
		await this.setInitialData(res, 'medicineDeliveryAddress');
		await this.closeCreateMedicineDeliveryAddressForm();
	}
	/**
	 * 処方箋送付先住所の登録
	 */
	public async onClickRegisterPrescriptionDeliveryAddress(): Promise<void> {
		this.errorPrescriptionDeliveryAddress = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.validatePrescriptionDeliveryAddressData.bind(this),
			{ view: this, data: this.newPrescriptionDeliveryAddress }
		);

		this.log(this.errorPrescriptionDeliveryAddress);

		if (this.errorPrescriptionDeliveryAddress.length > 0) {
			const messageList = this.errorPrescriptionDeliveryAddress.map((item) => item.message);
			this.showAlertDialog('住所登録エラー', messageList.join('<br>'));
			return;
		}

		// 自宅住所として登録する場合、上書きするかの確認ダイアログを表示
		// 自宅住所が登録されていない場合は表示しない
		if (this.newPrescriptionDeliveryAddress.type === 'PRIMARY' && this.data.isValidPrimaryAddress === true) {
			await this.showDialogWindow(
				HomeAddressOverridePopoverComponent,
				{
					userDeliveryAddress: this.newPrescriptionDeliveryAddress,
					primaryAddress: this.data.primaryAddress,
					registerAddress: this.execRegisterMedicineDeliveryAddress.bind(this),
					close: this.dismissDialogWindow.bind(this),
				}
			);
		} else {
			await this.execRegisterPrescriptionDeliveryAddress(this.newPrescriptionDeliveryAddress);
		}

	}

	public async execRegisterPrescriptionDeliveryAddress(data: UserDeliveryAddressDTOInterface): Promise<void> {
		const res = await this.registerPrescriptionDeliveryAddress(data);
		await this.setInitialData(res, 'prescriptionDeliveryAddress');
		await this.closeCreatePrescriptionDeliveryAddressForm();
	}

	/**
	 * 薬局の登録
	 */
	public async onClickRegisterStoreAddress(): Promise<void> {
		this.errorPrescriptionFaxStore = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.validatePrescriptionFaxStoreData.bind(this),
			{ view: this, data: this.newPrescriptionFaxStoreAddress }
		);

		this.log(this.errorPrescriptionFaxStore);

		if (this.errorPrescriptionFaxStore.length > 0) {
			const messageList = this.errorPrescriptionFaxStore.map((item) => item.message);
			this.showAlertDialog('住所登録エラー', messageList.join('<br>'));
			return;
		}

		const res = await this.registerStoreAddress(this.newPrescriptionFaxStoreAddress);
		await this.setInitialData(res, 'prescriptionFaxStore');
		await this.closeCreatePrescriptionFaxStoreForm();
	}

	/**
	 * お薬送付先登録フォームの表示
	 */
	public async openCreateMedicineDeliveryAddressForm(): Promise<void> {
		this.isOpenCreateMedicineDeliveryAddressForm = true;
	}

	public async closeCreateMedicineDeliveryAddressForm(): Promise<void> {
		this.newMedicineDeliveryAddress = {
			id: 0,
			type: 'PRIMARY',
			userId: 0,
			storeName: '',
			postCode: '',
			prefecture: '',
			city: '',
			address: '',
			building: '',
			toName: '',
			telNumber: '',
			faxNumber: '',
		};
		this.errorMedicineDeliveryAddress = [];
		this.isOpenCreateMedicineDeliveryAddressForm = false;
	}

	public async openCreatePrescriptionDeliveryAddressForm(): Promise<void> {
		this.isOpenCreatePrescriptionDeliveryAddressForm = true;
	}

	public async onClickEditPrescriptionDeliveryAddress(data: UserDeliveryAddressDTOInterface): Promise<void> {
		await this.openEditPrescriptionDeliveryAddress(data);
		return;
	}

	public async closeCreatePrescriptionDeliveryAddressForm(): Promise<void> {
		this.newPrescriptionDeliveryAddress = {
			id: 0,
			userId: 0,
			storeName: '',
			postCode: '',
			prefecture: '',
			city: '',
			address: '',
			building: '',
			toName: '',
			telNumber: '',
			faxNumber: '',
		};
		this.errorPrescriptionDeliveryAddress = [];
		this.isOpenCreatePrescriptionDeliveryAddressForm = false;
	}

	/**
	 * 薬局の削除
	 * @param data
	 */
	public async onClickDeleteMedicineAddress(data: UserDeliveryAddressDTOInterface): Promise<void> {

		const id = data.id;
		if (this.selectedPrescriptionDeliveryAddressId === id || this.selectedMedicineDeliveryAddressId === id) {
			this.showAlertDialog('住所が使用されています', 'お薬、処方箋の送付先として選択されているため削除できません');
			return;
		}

		this.deleteTargetMedicineDeliveryAddress = data;
		await this.showDialogWindow(
			PopoverConfirmComponent,
			{
				title: 'お薬の送付先削除',
				text: '住所を削除しますか？',
				close: this.execDeleteMedicineAddress.bind(this)
			}
		);

		return;
	}

	public async onClickEditMedicineDeliveryAddress(data: UserDeliveryAddressDTOInterface): Promise<void> {
		await this.openEditMedicineDeliveryAddress(data);
		return;
	}

	public async onClickEditHomeAddress(data: UserDeliveryAddressDTOInterface): Promise<void> {
		await this.openEditHomeAddress(data);
		return;
	}

	private async execDeleteMedicineAddress(isDelete: boolean): Promise<void> {
		const data = await this.deleteMedicineDeliveryAddress(this.deleteTargetMedicineDeliveryAddress);
		await this.setInitialData(data, 'medicine');
		this.deleteTargetMedicineDeliveryAddress = null;
	}

	/**
	 * 薬局の削除
	 * @param data
	 */
	public async onClickDeletePrescriptionAddress(data: UserDeliveryAddressDTOInterface): Promise<void> {

		const id = data.id;
		if (this.selectedPrescriptionDeliveryAddressId === id || this.selectedMedicineDeliveryAddressId === id) {
			this.showAlertDialog('住所が使用されています', 'お薬、処方箋の送付先として選択されているため削除できません');
			return;
		}

		this.deleteTargetPrescriptionDeliveryAddress = data;
		await this.showDialogWindow(
			PopoverConfirmComponent,
			{
				title: '処方箋の送付先削除',
				text: '住所を削除しますか？',
				close: this.execDeletePrescriptionAddress.bind(this)
			}
		);

		return;
	}

	private async execDeletePrescriptionAddress(isDelete: boolean): Promise<void> {
		//await this.dismissDialogWindow();
		const data = await this.deletePrescriptionDeliveryAddress(this.deleteTargetPrescriptionDeliveryAddress);
		await this.setInitialData(data);
		this.deleteTargetPrescriptionDeliveryAddress = null;
	}


	public async openCreatePrescriptionFaxStoreForm(): Promise<void> {
		this.isOpenCreatePrescriptionFaxStoreForm = true;
	}

	public async closeCreatePrescriptionFaxStoreForm(): Promise<void> {
		this.newPrescriptionFaxStoreAddress = {
			id: 0,
			userId: 0,
			storeName: '',
			postCode: '',
			prefecture: '',
			city: '',
			address: '',
			building: '',
			toName: '',
			telNumber: '',
			faxNumber: '',
		};
		this.errorPrescriptionFaxStore = [];
		this.isOpenCreatePrescriptionFaxStoreForm = false;
	}

	public async onClickEditStore(data: UserDeliveryAddressDTOInterface): Promise<void> {
		await this.openEditStoreAddress(data);
		return;
	}


	/**
	 * 薬局の削除
	 * @param data
	 */
	public async onClickDeleteStore(data: UserDeliveryAddressDTOInterface): Promise<void> {

		const id = data.id;
		if (this.selectedPrescriptionFaxStoreId === id) {
			this.showAlertDialog('薬局が選択されています', '処方箋FAX先として選択されているため削除できません');
			return;
		}

		this.deleteTargetStore = data;
		await this.showDialogWindow(
			PopoverConfirmComponent,
			{
				title: '薬局削除',
				text: '薬局を削除しますか？',
				close: this.execDeleteStore.bind(this)
			}
		);

		return;
	}

	private async execDeleteStore(isDelete: boolean): Promise<void> {
		//await this.dismissDialogWindow();
		const data = await this.deleteStoreAddress(this.deleteTargetStore);
		await this.setInitialData(data);
		this.deleteTargetStore = null;
	}

	public async onClickDialog(): Promise<void> {
		await this.showDialogWindow(
			HomeAddressOverridePopoverComponent,
			{
				userDeliveryAddress: this.newMedicineDeliveryAddress,
				close: this.dismissDialogWindow.bind(this),
			}
		);


	}
	protected readonly patternForPostCode = patternForPostCode;
	protected readonly patternForName = patternForName;
	protected readonly PrescriptionDeliveryTargetConst = PrescriptionDeliveryTargetConst;
}

